<template>
  <div class="profile-photo-container">
    <div class="profile-photo">
      <img
        :src="innerUrl || url || defaultProfile"
        alt="profile"
        :style="profileStyles"
      />
    </div>
    <template v-if="editable">
      <div class="profile-photo-input-label">
        <i v-if="!uploading" class="fas fa-pen"></i>
        <b-spinner v-if="uploading" style="width: 20px; height: 20px" />
        <input @change="profileInputHandler" ref="inputEl" type="file" />
      </div>
      <div
        v-if="url || innerUrl"
        @click="deleteProfile"
        class="profile-delete-button"
      >
        <i class="fa fa-times"></i>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    // file
    value: {},
    url: {
      type: String,
    },
    size: {
      type: String,
    },
    editable: {
      type: Boolean,
    },
    userId: {
      type: String,
    },
    defaultProfile: {
      type: String,
      default: "/assets/img/profiledefault.png",
    },
  },
  data() {
    return {
      innerUrl: "",
      uploading: false,
    };
  },
  computed: {
    profileStyles() {
      if (!this.size) {
        return {};
      }
      return {
        width: this.size,
        height: this.size,
      };
    },
  },
  methods: {
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    profileInputHandler(e) {
      const files = e.target.files;
      if (files[0]) {
        const new_profile_photo = files[0];
        if (new_profile_photo) {
          var url = URL.createObjectURL(new_profile_photo);
          this.innerUrl = url;
          this.getBase64(new_profile_photo).then((rsp) => {
            var avatar = rsp.split(",");
            this.$emit("input", avatar[1]);
          });
        }
      }
    },
    deleteProfile() {
      if (this.innerUrl) {
        this.innerUrl = "";
        this.$emit("input", "");
        var el = this.$refs.inputEl;
        el.value = null;
      } else {
        this.$emit("update:url", "");
        this.$emit("input", "");
      }
    },
  },
};
</script>
